/*

Array of object

Top level object can be:
1. Header
2. Group (Group can have navItems as children)
3. navItem

* Supported Options

/--- Header ---/

header

/--- nav Grp ---/

title
icon (if it's on top level)
tag
tagVariant
children

/--- nav Item ---/

icon (if it's on top level)
title
route: [route_obj/route_name] (I have to resolve name somehow from the route obj)
tag
tagVariant

*/
import _ from 'lodash'
import dashboard from './dashboard'
import orgPages from './org'
import personalPages from './personal'
import tools from './tools'
// import apps from './apps'
// import others from './others'
// import chartsAndMaps from './charts-and-maps'
// import uiElements from './ui-elements'
// import formAndTable from './forms-and-table'

// Array of sections
// export default [...dashboard, ...orgPages, ...personalPages, ...apps, ...uiElements, ...formAndTable, ...chartsAndMaps, ...others]
const pages = [...dashboard, ...orgPages, ...personalPages, ...tools]

export default pages

export const pagesHashmap = _.keyBy([...pages], 'route')
export const subpagesHashmap = _.keyBy(pages.map(item => item.children || []).flat(), 'route')